// extracted by mini-css-extract-plugin
export default {"container":"Secondary_container__UZI-g","active":"Secondary_active__esTdX"};